import DropdownUserOrganisationType from "root/ReactHookForm/ui/DropdownUserOrganisationType";
import ErrorDiv from "root/ReactHookForm/FormComponents/ErrorDiv";
import React, {Fragment} from "react";
import FormToggle from "root/ReactHookForm/ui/FormToggle";
import {UserTypes} from "root/DataFunctions/Constants";

import {useWatch} from "react-hook-form";
import {ModalUserModes} from "./ModalUserConstants";

import { IN_SCHOOL_TYPES } from "./ModalUser";
import {FormInput, SmartErrorDiv} from "root/ReactHookForm/FormComponents";
import { UserFieldNames} from "./ModalUserConstants";
import {emailPattern} from "root/ReactHookForm/FormComponents/FormInput";
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import DropdownSchools from "root/ReactHookForm/ui/DropdownSchools";

const validateOrganisationType = (val) => val === null ? "Please Select an organisation type." : undefined;
const validateSchool = (val) => val === null ? "Please Select a school." : undefined;

const FormFragmentUserDetails = ({isAttendanceOfficer, control, mode, user_type, register, formErrors, sectionName, readOnly, onClickEditTeacher}) =>
{
    const canBeOrganisation = user_type === UserTypes.CARER;

    const isUserOrganisation = useWatch({ control, name: "user.is_organisation" });

    const readOnlySchool = mode !== ModalUserModes.CREATE;

    const modeDependentRequired = !readOnly;

    const isInSchool = IN_SCHOOL_TYPES.has(user_type);

    return (
        <Fragment>
            { canBeOrganisation && <BootstrapRow>
                <BootstrapCol width={12}>
                    <label>User is an Organisation</label>
                    <div key='asas' className='pep-opt-out-row'>
                        <div key='k1' style={{fontStyle: 'italic', color: 'var(--s360-icon-blue)'}}>Select if Carer is a residential home</div>
                        <div key={'k3'} style={{justifySelf: 'right'}}>
                            <FormToggle readOnly={readOnly} control={control} name={`user.is_organisation`}/>
                        </div>
                    </div>
                </BootstrapCol>
            </BootstrapRow>}

            {isUserOrganisation &&
                <Fragment>
                    <BootstrapRow>
                        <BootstrapCol width={7}>
                            <label>Organisation Type</label>
                            <DropdownUserOrganisationType name='user.organisation_type_id' control={control} rules={{validate: validateOrganisationType}}
                                                          placeHolder='Please Select an organisation type' readOnly={false}/>
                            {formErrors.user?.organisation_type_id && <ErrorDiv>{formErrors.user.organisation_type_id.message}</ErrorDiv>}
                        </BootstrapCol>
                        <BootstrapCol width={5}>
                            <label>Education Attached?</label>
                            <div key='asas'>
                                <div key={'k3'} style={{paddingTop: '5px'}}>
                                    <FormToggle readOnly={false} control={control} name={`user.education_attached`}/>
                                </div>
                            </div>
                        </BootstrapCol>
                    </BootstrapRow>
                    <BootstrapRow>
                        <BootstrapCol width={12}>
                            <label>Organisation Name</label>
                            <input readOnly={readOnly} className='form-control' {...register("user.organisation_name", {required: true, maxLength: 100})} />
                            {formErrors.user?.organisation_name?.type === 'required' && <ErrorDiv>Please enter the organisation name</ErrorDiv>}
                        </BootstrapCol>
                    </BootstrapRow>
                </Fragment>
            }

            {(!isUserOrganisation && mode !== ModalUserModes.CREATE) && <BootstrapRow>
                <BootstrapCol width={12}>
                    <label>Username (Login)</label>
                    <input readOnly={true} className='form-control' {...register("user.username", { required: true, maxLength: 100 })} />
                    {formErrors.user?.user_name?.type === 'required' && <ErrorDiv>Please enter a User Name</ErrorDiv>}
                </BootstrapCol>
            </BootstrapRow>}

            {(isInSchool && mode === ModalUserModes.CREATE) &&
                <BootstrapRow>
                    <BootstrapCol width={12}>
                        <label className='col-form-label'>Select a school (Use the filter to narrow down the list)</label>
                        <DropdownSchools name={'user.school_id'} control={control} rules={{validate: validateSchool}}
                                         placeHolder='Pick a school' readOnly={readOnlySchool} isSearchable={true}/>
                        {formErrors.user?.school_id?.type === 'validate' && <ErrorDiv>Please select a school</ErrorDiv>}
                    </BootstrapCol>
                </BootstrapRow>
            }

            {(isInSchool && mode !== ModalUserModes.CREATE) && <BootstrapRow>
                <BootstrapCol width={12}>
                    <label>School Name</label>
                    <input readOnly={readOnlySchool} className='form-control' {...register("user.school_name", { required: true, maxLength: 100 })} />
                    {formErrors.user?.school_name?.type === 'required' && <ErrorDiv>Please enter a School Name</ErrorDiv>}
                </BootstrapCol>
            </BootstrapRow>}

            {(isAttendanceOfficer && mode !== ModalUserModes.CREATE) && <BootstrapRow>
                <div className='col-md-12'>
                    <div className='attendance-officer-warning'>This user is currently the assigned ATTENDANCE OFFICER for this school</div>
                </div>
            </BootstrapRow>}

            {(user_type === UserTypes.ATTENDANCE_OFFICER && !isAttendanceOfficer) && <BootstrapRow>
                <div className='col-md-12'>
                    <div className='attendance-officer-warning not'>This user is NOT currently the assigned attendance officer for this school</div>
                </div>
            </BootstrapRow>}

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>First Name</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.firstname", { required: true, maxLength: 100 })} />
                    <SmartErrorDiv sectionName='user' name='firstname' maxLength={100} formErrors={formErrors} />
                </div>
                <div className='col-md-6'>
                    <label>Last Name</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.surname", { required: true, maxLength: 100 })} />
                    {formErrors.user?.surname?.type === 'required' && <ErrorDiv>Please enter a last name less than 100 characters</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Address Line 1</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.address1", { required: modeDependentRequired, maxLength: 100 })} />
                    {formErrors.user?.address1?.type === 'required' && <ErrorDiv>Please enter an address</ErrorDiv>}
                </div>

                <div className='col-md-6'>
                    <label>Address line 2</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.address2", { required: false, maxLength: 100 })} />
                    {formErrors.user?.address2?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Address Line 3</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.address3", { required: false, maxLength: 100 })} />
                    {formErrors.user?.address3?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>

                <div className='col-md-6'>
                    <label>Address line 4</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.address4", { required: false, maxLength: 100 })} />
                    {formErrors.user?.address4?.type === 'required' && <ErrorDiv>Please enter a school name</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-6'>
                    <label>Postcode</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.postcode", { required: modeDependentRequired, maxLength: 10 })} />
                    {formErrors.user?.postcode?.type === 'required' && <ErrorDiv>Please enter a postcode</ErrorDiv>}
                </div>

                <div className='col-md-6'>
                    <label>Telephone</label>
                    <input readOnly={readOnly} className='form-control' {...register("user.telephone", { required: false, maxLength: 100 })} />
                    {formErrors.user?.telephone?.type === 'required' && <ErrorDiv>Please enter a telephone number</ErrorDiv>}
                </div>
            </BootstrapRow>

            <BootstrapRow>
                <div className='col-md-12'>
                    <FormInput readOnly={readOnly} label='Email Address'
                               sectionName='user' name={UserFieldNames.EMAIL} register={register} required={false} maxLength={100}
                               pattern={emailPattern} formErrors={formErrors}/>
                </div>
            </BootstrapRow>

        </Fragment>

    )
}

export default FormFragmentUserDetails;
